import { useMonitor } from '../use-monitor';

export function useMonitorCreateIssueFormLoad() {
  return useMonitor('create-issue-form-load');
}
